var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"modal d-block",on:{"click":function($event){return _vm.clickOutside($event)}}},[_c('div',{staticClass:"modal-backdrop show",style:({zIndex: 'unset'})}),_vm._v(" "),_c('div',{staticClass:"modal-dialog popup",class:_vm.modalSizeClass},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }